<template>
    <base-modal
        v-if="version"
        :visible="version !== null"
        :title="title"
        class="modal"
        max-height="100vh"
        @close="$emit('close')">

        <div v-if="detail.loading" class="loader"></div>

        <template v-else>
            <div class="title is-4">{{ detail.data.name }}</div><hr class="title-line"/>
            <div class="content scroll" v-html="detail.data.content"></div>
        </template>

        <base-button
            @click="restore_note"
            :loading="restore.loading"
            icon="fas fa-history"
            class="is-primary"
            text="Restore"/>&nbsp;

        <base-button
            @click="$emit('close')"
            icon="fas fa-times"
            class="is-danger"
            text="Close"/>
    </base-modal>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
    name: 'NoteDetailsVersionModal',
    props: ['space', 'note', 'version'],
    computed: {
        ...mapState('note_versions', ['detail', 'restore']),
        full_name() {
            return `${this.version.user.first_name} ${this.version.user.first_name}`;
        },
        date() {
            return moment(this.version.created_at).format('MMMM Do YYYY, h:mm:ss a');
        },
        title() {
            return `${this.full_name} (${this.date})`;
        },
    },
    watch: {
        version: {
            immediate: true,
            handler(version) {
                if (!version) {
                    return;
                }

                this.$store.dispatch('note_versions/detail', {
                    space_id: this.space.id,
                    note_id: this.note.id,
                    version_id: version.id,
                });
            },
        },
    },
    methods: {
        restore_note() {
            this.$store.dispatch('note_versions/restore', {
                space_id: this.space.id,
                note_id: this.note.id,
                version_id: this.version.id,
            }).then(() => {
                this.$emit('restored');
                this.$emit('close');
            });
        },
    },
};
</script>

<style scoped>
    .loader {
        margin-right: auto;
        margin-left: auto;
        margin-top: 4rem;
    }

    .hint {
        margin-bottom: 0.5rem;
    }

    .title {
        margin-bottom: 0.9rem;
    }

    .title-line {
        margin: 0;
    }

    .content {
        height: 40vh;
        padding-right: 0.5rem;
        padding-top: 0.7rem;
    }

    @media screen and (min-width: 769px), print {
        .modal >>> .modal-card {
            min-width: 800px;
        }
    }
</style>
